export default __webpack_public_path__ + "static/media/partners-banner-background.bce616b0.svg";